import VoiceTextArea from "@shared/components/form/VoiceTextArea";
import { Text } from "@shared/components/text";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

const FREE_TEXTAREA_STYLE = { height: 128 };

interface FreeTextInputProps {
  value?: string;
  onChangeText: (value: string) => void;
  voiceLocale: string;
  voiceMessages: { permissionDenied: string; notAvailable: string; error: string };
  showError?: boolean;
}

export const FreeTextInput = ({ value, onChangeText, voiceLocale, voiceMessages, showError }: FreeTextInputProps) => {
  const { t } = useTranslation();
  const hasError = showError && !value?.trim();

  return (
    <View className="flex-col gap-1">
      <VoiceTextArea
        rows={6}
        value={value}
        onChangeText={onChangeText}
        placeholder={t("screens.activities.questionnaire.freeTextPlaceholder")}
        textAreaStyle={FREE_TEXTAREA_STYLE}
        containerClassName={hasError
          ? "border border-red-500 rounded-lg p-3 relative"
          : "border border-gray-300 rounded-lg p-3 relative"
        }
        voiceToTextEnabled
        voiceLocale={voiceLocale}
        voiceMessages={voiceMessages}
      />
      {hasError && (
        <Text className="text-sm text-red-500">
          {t("screens.activities.questionnaire.requiredAnswer")}
        </Text>
      )}
    </View>
  );
};
